module.exports = __webpack_public_path__ + "img/roy-min.91fcb2a9.png";